import React , { Fragment } from 'react';
import '../Style/Projects.css';
import {Outlet} from 'react-router-dom';
import {Container,Grid,styled,Typography} from '@mui/material'
import {useSelector} from 'react-redux';
import ProjectItems from '../helpers/ProjectItems';
import AdPtojrcts from '../reklam/AdPtojrcts';
import Comunication from './Comunication';
import ComunicationPhone from './ComunicationPhone';
import ComunicationEmail from './ComunicationEmail';



function Projects() {
  const {dataItems} = useSelector ((store) => store.dataR);
  return (
    <Fragment>
      <Comunication/>
      <ComunicationPhone/>
      <ComunicationEmail/>
      <AdPtojrcts/>
      <Container sx={{marginBottom:3,marginTop:2}}>
      <Typography variant='h4' component='h4' sx={{marginBottom:2, textAlign:'center'}} className='projectWriting'>Tüm Projelerimiz</Typography>
        <Grid sx={{marginBottom:3}}>
          <Grid sx={{display:'flex', flexDirection:'row',flexWrap:'wrap', justifyContent:'center',gap:'20px'}}>
              {dataItems.map((Item, key) => {
                return(
                  <ProjectItems
                  key={key}
                  {...Item}
                  loading='lazy'
                  />
                )
              })}
          </Grid>
        </Grid>
      </Container>
      <Outlet/>
    </Fragment>
  )
}

export default Projects;